import { render, staticRenderFns } from "./NewsletterConfirm.vue?vue&type=template&id=40382f42&"
import script from "./NewsletterConfirm.vue?vue&type=script&lang=js&"
export * from "./NewsletterConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports